import { Heart } from "lucide-react";
import { Reveal } from "./Reveal";
import { ContactButton } from "./ContactFormDialog";
import { POUR_QUI } from "../../data/content";

export const PourQui = () => {
  return (
    <section
      id="pour-qui"
      data-testid="pourqui-section"
      className="relative overflow-hidden bg-pblv-ink py-24 text-pblv-bg md:py-32"
    >
      {/* soft glow */}
      <div className="pointer-events-none absolute -right-40 top-0 h-96 w-96 rounded-full bg-pblv-mauve/30 blur-[120px]" />
      <div className="pointer-events-none absolute -left-40 bottom-0 h-96 w-96 rounded-full bg-pblv-sage/20 blur-[120px]" />

      <div className="relative mx-auto max-w-[1400px] px-5 md:px-8">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-pblv-rose">
                Pour qui ?
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif text-4xl font-medium leading-[1.05] tracking-tight md:text-6xl">
                Vous êtes concernée
                <br />
                <span className="italic text-pblv-rose">si…</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-6 max-w-md text-lg leading-relaxed text-pblv-bg/70">
                T'POZ s'adresse aux femmes de plus de 40 ans traversant une
                période de vulnérabilité ou de transition de vie et ayant besoin
                d'un temps de répit. L'accès est étudié selon les critères
                définis par l'association.
              </p>
            </Reveal>
            <Reveal delay={0.28}>
              <div className="mt-6 flex flex-wrap gap-3" data-testid="eligibilite-infos">
                <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2 text-sm font-semibold text-pblv-bg/90">
                  <Heart className="h-4 w-4 text-pblv-rose" strokeWidth={1.8} />
                  Accès sans adhésion
                </span>
                <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2 text-sm font-semibold text-pblv-bg/90">
                  <Heart className="h-4 w-4 text-pblv-rose" strokeWidth={1.8} />
                  Jusqu'à 3 T'POZ par an
                </span>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <ul className="flex flex-col gap-4">
              {POUR_QUI.femmes.map((item, i) => (
                <Reveal key={i} delay={i * 0.08} y={24}>
                  <li className="flex items-start gap-4 rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm transition-colors duration-300 hover:bg-white/10">
                    <span className="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-pblv-rose/20 text-pblv-rose">
                      <Heart className="h-4.5 w-4.5" strokeWidth={1.8} />
                    </span>
                    <span className="text-lg leading-snug text-pblv-bg/90">
                      {item}
                    </span>
                  </li>
                </Reveal>
              ))}
              <Reveal delay={0.1}>
                <ContactButton
                  subject="Je souhaite vivre une T'POZ"
                  testId="pourqui-cta"
                  className="mt-4 inline-flex w-fit items-center gap-2 rounded-full bg-pblv-bg px-7 py-4 text-sm font-semibold text-pblv-ink transition-all duration-300 hover:-translate-y-1 hover:bg-pblv-rose"
                >
                  Je souhaite vivre une T'POZ
                </ContactButton>
              </Reveal>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PourQui;
